var render, staticRenderFns
import script from "./ScatterChart.vue?vue&type=script&lang=js&"
export * from "./ScatterChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7e4ee70')) {
      api.createRecord('c7e4ee70', component.options)
    } else {
      api.reload('c7e4ee70', component.options)
    }
    
  }
}
component.options.__file = "@shared/Charts/Graphs/ScatterChart.vue"
export default component.exports